import { render, staticRenderFns } from "./NameForm.vue?vue&type=template&id=527533da&"
import script from "./NameForm.vue?vue&type=script&lang=ts&"
export * from "./NameForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports